import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { UsersComponent } from './users/users.component';
import { CompetitionComponent } from './competition/competition/competition.component';
import { InvitationComponent } from './invitation/invitation.component';
import { RecoveryComponent } from './recovery/recovery.component';
import { CompetitionImagesComponent } from './competition-images/competition-images.component';
import { CompetitionVotesComponent } from './competition-votes/competition-votes.component';
import { CompetitionResultComponent } from './competition-result/competition-result.component';
import { CompetitionPresentationComponent } from './competition-presentation/competition-presentation.component';
import { VideoplayerComponent } from './help/videoplayer/videoplayer.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsComponent } from './terms/terms.component';
import { DeletionComponent } from './deletion/deletion.component';
import { AboutComponent } from './about/about/about.component';
import { RegisterComponent } from './about/register/register.component';
import { UploadComponent } from './about/upload/upload.component';
import { VoteComponent } from './about/vote/vote.component';
import { AbouttComponent } from './about/about.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  { path: 'home', component: HomeComponent },
  { path: 'users', component: UsersComponent },
  { path: 'competition', component: CompetitionComponent },
  { path: 'addcompetitionimages', component: CompetitionImagesComponent },
  { path: 'votecompetition', component: CompetitionVotesComponent },
  { path: 'competitionresult', component: CompetitionResultComponent },
  { path: 'invitation/:hash', component: InvitationComponent },
  { path: 'competitionpresentation', component: CompetitionPresentationComponent },
  { path: 'privacy', component: PrivacyPolicyComponent },
  { path: 'terms', component: TermsComponent },
  { path: 'about/about', component: AboutComponent },
  { path: 'about', component: AbouttComponent },
  { path: 'about/register', component: RegisterComponent },
  { path: 'about/upload', component: UploadComponent },
  { path: 'about/vote', component: VoteComponent },
  { path: 'deletion', component: DeletionComponent },
  { path: 'help/:fil', component: VideoplayerComponent },
  { path: 'pwdreset/:hash', component: RecoveryComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
